import type { RiskAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetRiskAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetRiskAuditByIdArgs = {
  id: string;
};

export const useGetRiskAuditById = createQueryHook<
  UseGetRiskAuditByIdArgs,
  RiskAuditByIdResponseRow[],
  AuditLogQueryResult<'risk_audit', RiskAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getRiskAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ risk_audit: data }),
  graphqlDocument: GetRiskAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
